/**
 * @class
 * @param {Object} par
 * @extends mkE.Base
 */
T.AddToCalendar = Class(
	/**
	 * @lends {T.AddToCalendar#}
	 */
	{
		/** @type {Object} */
		par: null,

		CALENDARS: ['google', 'apple', 'outlook'],

		/** @param {Object} par */
		__construct( par ) {
			this.par = par;

			let options = [{
				value: '',
				caption: D.Lang.get('t.add_to_calendar.default')
			}];

			for( let i = 0; i < this.CALENDARS.length; i++ ) {
				const calendar = this.CALENDARS[i];
				options.push({
					value: calendar,
					caption: D.Lang.get(`t.add_to_calendar.${calendar}`)
				});
			}

			this.node = mkE({
				tag: 'div',
				className: 'addToCalendar',
				els: [
					this._select = new T.Form.Select({
						border: true,
						onChange: this.onSelect,
						options: options,
						value: ''
					})
				]
			})
		},

		onSelect() {
			let url = '';
			const type = this._select.value();
			switch( type ) {
				case 'google':
					url = this.getUrlGoogle(this.par);
					break;
				case 'apple':
					url = this.getUrlApple(this.par);
					break;
				case 'outlook':
					url = this.getUrlMicrosoft(this.par);
					break;
				default:
					return;
			}
			if( url ) {
				D.addStats('web_add_to_cal_' + type);
				window.open(url);
			}
			this._select.value('');
		},

		formatDate( ts, withoutDelimiters = false ) {
			let date = new Date(ts * 1000);
			date = date.toISOString().replace('.000', '');
			if( withoutDelimiters ) {
				date = date.replace(/-/g, '').replace(/:/g, '');
			}
			return date;
		},

		getUrlGoogle( data ) {
			let url = new Get('https://calendar.google.com/calendar/render?action=TEMPLATE')
			url.add('dates', this.formatDate(data.startDate, true) + '/' + this.formatDate(data.endDate, true))
			if( data.title != null && data.title !== '' ) {
				url.add('text', data.title);
			}
			if( data.description != null && data.description !== '' ) {
				let description = data.description;
				description += "\n\n<a href=\"" + data.url + "\">" + data.url + "</a>";
				url.add('details', description);
			}
			if( data.location != null && data.location !== '' ) {
				url.add('location', data.location);
			}
			return url.toUrl();
		},

		// getUrlYahoo( data ) {
		// 	let url = new Get('https://calendar.yahoo.com/?v=60')
		// 	url.add('st', this.formatDate(data.startDate, true))
		// 	url.add('et', this.formatDate(data.endDate, true));
		// 	if( data.title != null && data.title !== '' ) {
		// 		url.add('title', data.title);
		// 	}
		// 	if( data.description != null && data.description !== '' ) {
		// 		url.add('desc', data.description);
		// 	}
		// 	if( data.location != null && data.location !== '' ) {
		// 		url.add('in_loc', data.location);
		// 	}
		// 	return url.toUrl();
		// },

		getUrlMicrosoft( data ) {
			let url = new Get('https://outlook.live.com/calendar/0/deeplink/compose')
			url.add('path', '/calendar/action/compose')
			url.add('rru', 'addevent')
			url.add('startdt', this.formatDate(data.startDate))
			url.add('enddt', this.formatDate(data.endDate));
			if( data.title != null && data.title !== '' ) {
				url.add('subject', data.title);
			}
			if( data.description != null && data.description !== '' ) {
				url.add('body', data.description.replace(/\n/g, '<br>') + '<br><br>' + data.url);
			}
			if( data.location != null && data.location !== '' ) {
				url.add('location', data.location);
			}
			return url.toUrl();
		},

		// getUrlTeams( data ) {
		// 	let url = new Get('https://teams.microsoft.com/l/meeting/new')
		// 	url.add('startTime', this.formatDate(data.startDate))
		// 	url.add('endTime', this.formatDate(data.endDate))
		// 	if( data.title != null && data.title !== '' ) {
		// 		url.add('subject', data.title);
		// 	}
		// 	if( data.description != null && data.description !== '' ) {
		// 		url.add('content', data.description);
		// 	}
		// 	return url.toUrl();
		// },

		getUrlApple( data ) {
			let now = (new Date()).toISOString();
			let timeslot = '';
			const ics_lines = ['BEGIN:VCALENDAR', 'VERSION:2.0'];
			ics_lines.push('PRODID:-// roadgames.com // atcb v1.13.2 //EN');
			ics_lines.push('CALSCALE:GREGORIAN');
			ics_lines.push('BEGIN:VEVENT');
			ics_lines.push('UID:' + now + '@roadgames.com');
			ics_lines.push(
				'DTSTAMP:' + this.formatDate(data.startDate, true),
				'DTSTART' + timeslot + ':' + this.formatDate(data.startDate, true),
				'DTEND' + timeslot + ':' + this.formatDate(data.endDate, true),
				'SUMMARY:' + data.title.replace(/.{65}/g, '$&' + '\r\n ')
			);
			if( data.description != null && data.description !== '' ) {
				ics_lines.push('DESCRIPTION:' + data.description.replaceAll(/\r\n/g, '\\n') + '\\n\\n' + data.url);
			}
			if( data.location != null && data.location !== '' ) {
				ics_lines.push('LOCATION:' + data.location);
			}
			now = now.replace(/\.\d{3}/g, '').replace(/[^a-z\d]/gi, '');
			ics_lines.push('STATUS:CONFIRMED', 'LAST-MODIFIED:' + now, 'SEQUENCE:0', 'END:VEVENT', 'END:VCALENDAR');
			return 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics_lines.join('\r\n'));
		}
	},
	mkE.Base
);